import React from 'react';
import { Link } from 'react-router-dom';
import { ChevronRight } from 'lucide-react';

export default function Breadcrumb({ items = [] }) {
  return (
    <nav className="flex items-center gap-2 text-sm text-[#7A857F]">
      {items.map((item, i) => (
        <React.Fragment key={`${item.label}-${i}`}>
          {i > 0 && <ChevronRight size={13} className="text-[#C9C0A8]" />}
          {item.to ? (
            <Link to={item.to} className="hover:text-[#1A2622] transition-colors">{item.label}</Link>
          ) : (
            <span className="text-[#1A2622] font-medium">{item.label}</span>
          )}
        </React.Fragment>
      ))}
    </nav>
  );
}
